export default __webpack_public_path__ + "media/images/loading-4d733ffb847fa87eba4a99536f944a1f.gif";